import { inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { openSmallConfirmDialog } from "@app/modules/ui-notification/smallConfirmDialog/confirmDialog.component";
import { AuthService } from "@core/auth/auth.service";
import { SpaceService } from "@core/spaces/spaces.service";
import { UserService } from "@core/user/user.service";
import { map, of, switchMap } from "rxjs";

export const SpaceGuard: (s: string) => CanActivateFn | CanActivateChildFn = space => (route, state) => {
    const router: Router = inject(Router);
    const _userService = inject(UserService)
    const _matDialog = inject(MatDialog)
    const _spaceService = inject(SpaceService)

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                const redirectURL =
                    state.url === '/sign-out'
                        ? ''
                        : `redirectURL=${encodeURIComponent(state.url)}`;
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param

                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }
                return _userService.user$.pipe(switchMap(u => {
                    const result = space == 'normal' || u.spaces.includes(space)
                    if (!result) {
                        console.log(u.spaces, result)
                        router.navigate(['/'], { queryParams: { redirectURL: redirectURL } }).then(
                            (navigated: boolean) => {
                                openSmallConfirmDialog(_matDialog, "Forbidden", `You are NOT allowed to access the ${space} Space`, "OK")
                            }
                        );
                        return of(false)
                    }
                    return _spaceService.setSpace(space).pipe(map(_ => true))
                }))
            }),
        )
        ;
};